let $newsLetters;

(function( $ ) {
    'use strict';
    $(function(){
        if (typeof datalayer_info === 'undefined') {
            return;
        }

        window.dataLayer = window.dataLayer || [];
        if (datalayer_info.hasOwnProperty('load')) {
            window.dataLayer.push(datalayer_info['load']);
        }

        if (datalayer_info.hasOwnProperty('orderButtonClick')) {
            jQuery(document).on('click', '.js-order-button', function(evt) {
                if (!jQuery(evt.target).hasClass('is-disabled')) {
                    window.dataLayer.push(datalayer_info['orderButtonClick']);
                }
            });
        }

        if (datalayer_info.hasOwnProperty('newsletterInView')) {
          $newsLetters = $('.js-newsletter');
          let isAddedToDL = false;

          if ($newsLetters.length >= 1) {
            newsletterToDL($newsLetters);
          }

          jQuery(document).scroll(function() {
            if ($newsLetters.length >= 1) {
              newsletterToDL($newsLetters);
            }
          });

          function newsletterToDL($newsLetters) {
            $newsLetters.each(function() {
              let inViewport = $(this).isInViewport();
              if (inViewport && !isAddedToDL) {
                  let pageUrl = window.location.href;
                  let deviceType = getDeviceType();
                  
                  datalayer_info['newsletterInView'] = {
                    'page_url': pageUrl,
                    'device_category': deviceType,
                    'event': 'newsletter_section_in_view'
                  }
                  
                  window.dataLayer.push(datalayer_info['newsletterInView']);
                  isAddedToDL = true;
              }
            });
          }
          
        }

    }); // End of DOM Ready

})( jQuery );
